module.exports = __webpack_public_path__ + "img/title_lsf16_atlantis.91725498.png";